import { useState } from 'react';
import { useMapContext } from "../Map/MapContext";

export const useMapLayer = () => {

    const { layersVisible, setLayersVisible, colorScheme, setColorScheme } = useMapContext();

    // const [colorScheme, setColorScheme] = useState('standard'); // The subcatchment layer color scheme, set by dropdown menu
    // const [layersVisible, setLayersVisible] = useState(false); // Button that opens up color scheme dropdown menu

    // Sets the color scheme for the subcatchment layer when an item is selected from the dropdown menu
    const handleColorSchemeChange = (event) => {
        setColorScheme(event.target.value);
    };

    // Toggle the visibility of the color scheme dropdown menu
    const handleToggleLayers = () => {
        setLayersVisible(!layersVisible);
        setColorScheme('standard');
    };

    return {
        colorScheme,
        layersVisible,
        handleColorSchemeChange,
        handleToggleLayers,
    };
};
